import { useQuery, type UseQueryResult } from "@tanstack/react-query";
import { useApiClient } from "../apiClientContext";
import {
    fetchServiceInfo,
    fetchSession,
    type ServiceInfoResponse,
    type SessionResponse,
} from "./api";

export const SESSION_QUERY_KEY = ["session"] as const;
export const SERVICE_INFO_QUERY_KEY = ["service-info"] as const;

/**
 * iteration-0 connectivity probe. The frontend signs in via MSAL, then
 * issues this call to prove the API accepts the resulting Bearer token.
 */
export function useSession(): UseQueryResult<SessionResponse, Error> {
    const client = useApiClient();
    return useQuery({
        queryKey: SESSION_QUERY_KEY,
        queryFn: () => fetchSession(client),
        staleTime: 60_000,
    });
}

export function useServiceInfo(): UseQueryResult<ServiceInfoResponse, Error> {
    const client = useApiClient();
    return useQuery({
        queryKey: SERVICE_INFO_QUERY_KEY,
        queryFn: () => fetchServiceInfo(client),
        staleTime: 60_000,
    });
}
